import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  transform(value: string): string {
    return `${value.substring(4, 6)}/${value.substring(6, 8)}/${value.substring(0, 4)} ${value.substring(8, 10)}:${value.substring(10, 12)}`;
  }
}
